import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { showSuccess, showError, showDeliveryThreshold } from 'app/globalMessages/globalMessagesClient';
import AddProductButton from 'app/commonComponents/addProduct/addProductButton';
import { useAddToBag, useAddToWishlist } from 'app/commonComponents/addProduct/addProductHooks';
import AddProductError from 'app/commonComponents/addProduct/addProductError';
import {
  ATB_STATE,
  getWishlistButtonState,
  ADD_TO_BUG_SUCCESS_MESSAGE_ID,
  OUT_OF_STOCK_ERROR_MESSAGE_ID,
  ADD_TO_WISHLIST_SUCCESS_MESSAGE_ID,
  STATUS_CODES,
} from 'app/commonComponents/addProduct/addProductConstants';
import {
  ABOVE_THRESHOLD_MSG,
  FREE_DELIVERY_VISIBLE,
  DISPLAY_SECONDS,
  getBelowThresholdMsg,
  THRESHOLD,
  ABOVE_THRESHOLD_BG,
  BELOW_THRESHOLD_BG,
} from 'app/utils/freeDeliveryUtils';

function AddProduct({ detailsPage, prependPrice, onNotifyAction, isSelectSizeErrorVisible }) {
  const { addToBagState, isAddToBagClicked, addToBag } = useAddToBag({
    selectedSize: detailsPage.selectedSize,
    hasStock: detailsPage.hasStock,
    product: detailsPage.loadedProduct,
    location: 'product',
    disableNotifyMe: detailsPage.disableNotifyMe,
  });

  const { addToWishlistState, isAddToWishlistClicked, addToWishlist } = useAddToWishlist({
    selectedSize: detailsPage.selectedSize,
    hasStock: detailsPage.hasStock,
    product: detailsPage.loadedProduct,
    disableNotifyMe: detailsPage.disableNotifyMe,
  });

  const selectedSizeOutOfTheStock = addToBagState === STATUS_CODES.SIZE_OUT_OF_STOCK;

  const addToBagButtonState = ATB_STATE[addToBagState];
  const addToWishlistButtonState = getWishlistButtonState(addToWishlistState, {
    noText: false,
    isProductInWishlist: detailsPage.loadedProduct.inWishlist,
  });
  const [isAddToBagActive, setIsAddToBagActive] = useState(true);

  function onAddToBagClick() {
    setIsAddToBagActive(true);
    addToBag().then(
      json => {
        if (json) {
          if (FREE_DELIVERY_VISIBLE) {
            if (json.subTotalWithoutDiscountsValue < THRESHOLD) {
              showDeliveryThreshold({
                message: getBelowThresholdMsg(json.subTotalWithoutDiscountsValue),
                autoHide: true,
                sticky: true,
                displayTime: DISPLAY_SECONDS,
                customColor: BELOW_THRESHOLD_BG,
              });
            } else {
              showDeliveryThreshold({
                message: ABOVE_THRESHOLD_MSG,
                autoHide: true,
                sticky: true,
                displayTime: DISPLAY_SECONDS,
                customColor: ABOVE_THRESHOLD_BG,
              });
            }
          } else {
            showSuccess({
              messageId: ADD_TO_BUG_SUCCESS_MESSAGE_ID,
              autoHide: true,
              sticky: true,
            });
          }
        }
      },
      () => {
        showError({
          messageId: OUT_OF_STOCK_ERROR_MESSAGE_ID,
          autoHide: true,
          sticky: true,
        });
      }
    );
  }

  function onAddToWishlistClick() {
    if (addToWishlistButtonState.disabled) {
      return;
    }
    setIsAddToBagActive(false);
    addToWishlist().then(json => {
      if (json) {
        showSuccess({
          messageId: ADD_TO_WISHLIST_SUCCESS_MESSAGE_ID,
          autoHide: true,
          sticky: true,
        });
      }
    });
  }

  return (
    <div className="product__add-product-container">
      <AddProductError
        // the sticky bar scrolls the customer here and asks for the 'Please select a size' message to be displayed
        isButtonClicked={(isAddToBagActive ? isAddToBagClicked : isAddToWishlistClicked) || isSelectSizeErrorVisible}
        buttonState={isAddToBagActive || selectedSizeOutOfTheStock ? addToBagButtonState : addToWishlistButtonState}
      />
      <div className="product__add-product-wrapper">
        <AddProductButton
          onClick={selectedSizeOutOfTheStock || !detailsPage.hasStock ? onNotifyAction : onAddToBagClick}
          prependPrice={prependPrice && !selectedSizeOutOfTheStock ? detailsPage.loadedProduct.price : null}
          buttonState={addToBagButtonState}
        />
        <AddProductButton onClick={onAddToWishlistClick} buttonState={addToWishlistButtonState} />
      </div>
    </div>
  );
}

AddProduct.defaultProps = {
  prependPrice: null,
  isSelectSizeErrorVisible: false,
};

AddProduct.propTypes = {
  prependPrice: PropTypes.string,
  isSelectSizeErrorVisible: PropTypes.bool,
  detailsPage: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AddProduct;
